export type Tone = 'default' | 'accent' | 'muted' | 'danger' | 'success' | 'warning';

/** The six label tones a `Badge` paints over the categorical chart series (`--color-chart-1..6`). A label
 *  tone is a stored choice that tells labels apart (a board's labels), never a state, so it has no text
 *  colour in `TONE_TEXT`. */
export type LabelTone = 'label-1' | 'label-2' | 'label-3' | 'label-4' | 'label-5' | 'label-6';

/** Canonical tone → text-color class. Shared by every surface that colors text/icons by tone
 *  (timeline, event stream, dashboard signals) so a palette change lives in one place. */
export const TONE_TEXT: Record<Tone, string> = {
  default: 'text-muted-foreground',
  accent: 'text-primary',
  muted: 'text-muted-foreground',
  danger: 'text-destructive',
  success: 'text-success',
  warning: 'text-warning',
};
